"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const imageInputStyles = react_native_1.StyleSheet.create({
    thumbnail: {
        width: 60,
        height: 60,
    },
    text: {
        flex: 7,
        justifyContent: 'center',
        paddingLeft: 8,
    },
    iconContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        height: 48,
        minWidth: 25,
        top: 3,
        backgroundColor: colors_1.default.COLOR_BLUE,
    },
    selectedContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 8,
        padding: 7,
        marginVertical: 5,
        maxHeight: 40,
        backgroundColor: colors_1.default.COLOR_PRIMARY,
    },
});
exports.default = imageInputStyles;
